var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[_c('ul-line-chart',{style:([_vm.isDashboard ? { height: '250px' } : {}]),attrs:{"chart-data":_vm.pointBalanceChartData,"chart-options":_vm.pointBalanceChartOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }